import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { auth } from "../../firebase/firebaseConfig";
import { LogoutConfirmationDialog } from "./LogoutConfirmationDialog";

interface LogoutButtonProps {
	fullWidth?: boolean;
	sx?: object;
	children?: React.ReactNode;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({
	fullWidth = false,
	sx,
	children = "Log out"
}) => {
	const navigate = useNavigate();
	const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

	const handleLogoutClick = () => {
		setLogoutConfirmOpen(true);
	};

	const handleLogoutCancel = () => {
		setLogoutConfirmOpen(false);
	};

	const handleLogoutConfirm = async () => {
		try {
			await auth.signOut();
			navigate("/login", { replace: true });
		} catch (error) {
			console.error("Logout failed:", error);
		}
		setLogoutConfirmOpen(false);
	};

	return (
		<>
			<Button
				fullWidth={fullWidth}
				variant="outlined"
				startIcon={<LogoutIcon />}
				onClick={handleLogoutClick}
				sx={sx}
			>
				{children}
			</Button>
			<LogoutConfirmationDialog
				open={logoutConfirmOpen}
				onClose={handleLogoutCancel}
				onConfirm={handleLogoutConfirm}
			/>
		</>
	);
};
